<template>
  <div class="whole-network-page">
    <div class="whole-network-page-content">
      <div class="row whole-network-tab">
        <div class="row">
          <div
            class="tab-item" 
            :class="{'tab-item-active': item === selectedOptionTab}" 
            v-for="(item, index) in wholeNetworkTabs" 
            :key="index"
            @click="onTabClick(item)"
            >
            {{item}}
          </div>
        </div>
        <div>
          <header-search-input
            :showArrow="false"
            class="search-input"
            @change="onSearchInputChange"
            @searchCompany="onSearchCompany"
          ></header-search-input>
        </div>
      </div>
      <news-list v-if="selectedOptionTab === '公司舆情'"></news-list>
      <IndustryNewsModule v-if="selectedOptionTab === '产业舆情'"></IndustryNewsModule>
      <macroscopic-list v-if="selectedOptionTab === '宏观舆情'"></macroscopic-list>
      <whole-network-person-news-list :personNameData="[]" v-if="selectedOptionTab === '人物舆情'"></whole-network-person-news-list>
    </div>
  </div>
</template>

<script>
import NewsList from '@/components/news-monitor/NewsListV3';
import IndustryNewsModule from '@/components/whole-network/IndustryNewsModule';
import WholeNetworkPersonNewsList from '@/components/whole-network/WholeNetworkPersonNewsList';
import MacroscopicList from '@/components/news-monitor/MacroscopicList';
import HeaderSearchInput from '@/components/common/HeaderSearchInput';

export default {
  data() {
    return {
      wholeNetworkTabs: ['公司舆情', '产业舆情', '宏观舆情', '人物舆情'],
      selectedOptionTab: '公司舆情'
    };
  },
  methods: {
    onSearchInputChange({ searchText, type }) {
      if (type === 'company') {
        if (this.$route.path === '/result' && this.$route.query.type === 'perimeter') {
          this.$router.push({
            name: 'result-page',
            query: {
              type: 'perimeter',
              q: searchText
            }
          });
        } else {
          this.$router.push({
            name: 'result-page',
            query: {
              q: searchText
            }
          });
        }
      } else if (type === 'person') {
        this.$router.push({
          name: 'person',
          query: {
            q: searchText
          }
        });
      }
    },
    onSearchCompany(searchText) {
      this.$router.push({
        name: 'search-result-page',
        query: {
          q: searchText
        }
      });
    },
    onTabClick(res) {
      this.selectedOptionTab = res;
      if (this.selectedOptionTab === '公司舆情') {
        this.$router.push({
          path: '/whole-network'
        });
      } else if (this.selectedOptionTab === '产业舆情') {
        this.$router.push({
          path: '/whole-network',
          query: {
            type: 'industry'
          }
        });
      } else if (this.selectedOptionTab === '宏观舆情') {
        this.$router.push({
          path: '/whole-network',
          query: {
            type: 'macroscopic'
          }
        });
      } else if (this.selectedOptionTab === '人物舆情') {
        this.$router.push({
          path: '/whole-network',
          query: {
            type: 'person'
          }
        });
      } 
    }
  },
  components: {
    NewsList,
    WholeNetworkPersonNewsList,
    IndustryNewsModule,
    MacroscopicList,
    HeaderSearchInput
  },
  created() {
    this.$nextTick(() => document.querySelector('.whole-network-tab').scrollIntoView({ block: 'center' }));
  },
  mounted() {
    if (this.$route.query.type === 'industry') {
      this.selectedOptionTab = '产业舆情';
    } else if (this.$route.query.type === 'macroscopic') {
      this.selectedOptionTab = '宏观舆情';
    } else if (this.$route.query.type === 'person') {
      this.selectedOptionTab = '人物舆情';
    } else {
      this.selectedOptionTab = '公司舆情';
    } 
  }
};
</script>

<style lang="scss" scoped>
.whole-network-page {
  width: 100%;
  min-width: 1000px;
  min-height: 100%;
  background: #f7f7fa;
  .whole-network-page-content {
    margin: 0 auto;
    padding: 16px 0;
    width: 1200px;
    min-height: calc(100vh - 59px);
    .whole-network-tab {
      justify-content: space-between;
      padding: 12px 24px;
      width: 1200px;
      height: 44px;
      color: #747990;
      background-color: #ffffff;
      font-size: 14px;
      box-shadow: inset 0px -1px 0px 0px#f2f3f7;
      .tab-item {
        margin-right: 32px;
        cursor: pointer;
        &:hover {
          color: #45a8cc;
        }
      }
      .tab-item-active {
        color: #45a8cc;
      }
      .search-input {
        width: 340px;
      }
    }
  }
}
</style>
